import { initActions, successActions } from '../actions/savingUpdatesTextActions';
import initialState from './initialState';

export default function savingUpdatesTextReducer(state = initialState.savingUpdatesText, action) {

  if (initActions[action.type]) {
    return 'Saving...';
  }

  if (successActions[action.type]) {
    return 'All changes saved';
  }

  return state;
}


// WEBPACK FOOTER //
// ./src/reducers/savingUpdatesTextReducer.js